import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UnitSystem } from './unit-system.types';

@Injectable({ providedIn: 'root' })
export class UnitSystemService {
    private readonly storageKey = 'unitSystem';
    private readonly unitSystemSubject = new BehaviorSubject<UnitSystem>(this.readStoredUnitSystem());

    readonly unitSystem$: Observable<UnitSystem> = this.unitSystemSubject.asObservable();

    get value(): UnitSystem {
        return this.unitSystemSubject.value;
    }

    setUnitSystem(unitSystem: UnitSystem): void {
        localStorage.setItem(this.storageKey, unitSystem);
        this.unitSystemSubject.next(unitSystem);
    }

    private readStoredUnitSystem(): UnitSystem {
        const storedUnitSystem = localStorage.getItem(this.storageKey);

        return storedUnitSystem === 'imperial' || storedUnitSystem === 'international'
            ? storedUnitSystem
            : 'international';
    }
}

